import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { Advantages } from '../../components/Advantages';
import { TENANTS_ADVANTAGES_ITEMS } from '../../components/Advantages/utils/constants';
import { HowItWork } from '../../components/HowItWork';
import { tenantContent } from '../../components/HowItWork/constants';
import { Layout } from '../../components/Layout';
import { VIEWED_TIMEOUT } from '../../constants/timeouts';
import { useTeaserTracking } from '../../hooks/useTeaserTracking';
import { IScrollRef } from '../../types/page/scrolling';

export const TenantPage: React.FC<IScrollRef> = ({ howItWorkRef }) => {
  const { trackShowAdvantages, trackShowSteps } = useTeaserTracking();

  return (
    <Layout>
      <ActionAfterViewObserver callback={trackShowAdvantages} callbackDelay={VIEWED_TIMEOUT}>
        <Advantages testId="TenantAdvantages" heading="Чем он лучше обычного" items={TENANTS_ADVANTAGES_ITEMS} />
      </ActionAfterViewObserver>

      <ActionAfterViewObserver callback={trackShowSteps} callbackDelay={VIEWED_TIMEOUT}>
        <HowItWork content={tenantContent} howItWorkRef={howItWorkRef} />
      </ActionAfterViewObserver>
    </Layout>
  );
};
